<script lang="ts">
	import {uqnArray} from './stores.js';
	import check from './check_random/check';
	import random from './check_random/random';
	import Textfield, {Input, Textarea} from '@smui/textfield';
	import Button, {Label, Icon} from '@smui/button';
	import Dialog, {Title, Content, Actions} from '@smui/dialog';
	import Slider from '@smui/slider';
	import FormField from '@smui/form-field';
	import Katex from './Katex.svelte';
	import Radio from '@smui/radio';
	import getRandomInt from './functions/getRandomInt';
	import uqnSplit from './functions/uqnSplit';
	import uqnJoin from './functions/uqnJoin';
	import QnComponent from './QnComponent.svelte';
	import signAssign from './functions/signAssign';
	import Fraction from './functions/fractionClass';
	import fractionBuilder from './functions/fractionBuilder.js';

	let uqnInput: number;
	let simpleDialog;
	
	let aSlide: number, a: number, bSlide: number, b: number;
	let sign: number;
	let typeGroup1: string;
	let r: number, rSlide: number, theta:number, thetaSlide: number;
	let nKatex: string, nSlide: number, n: number;
	let nKatex2: string, nKatex3: string, thetaSlide2: number, thetaSlide3: number;
	let realImagRadio: string;
	let multiplyGroup: string;
	let _;

	// initialize
	let type = $uqnArray[0].toString()[0];
	if ($uqnArray[0].toString().length == 7){
		type = "5";
		typeGroup1 = "5";
		multiplyGroup = $uqnArray[0].toString()[0];
	} else if ($uqnArray[0].toString()[0]=="1" || $uqnArray[0].toString()[0]=="3"){
		typeGroup1 = "1";
	} else if ($uqnArray[0].toString()[0]=="2" || $uqnArray[0].toString()[0]=="4"){
		typeGroup1 = "2";
	} else if ($uqnArray[0].toString()[0]=="6"){
		typeGroup1 = "6";
		realImagRadio = $uqnArray[0].toString()[3];
	}
	$: _ = updateFromRadio1(typeGroup1);
	$: _ = updateFromRadio2(type);
	$: _ = updateFromRadio3(multiplyGroup);
	$: _ = updateFromRadio4(realImagRadio);
	$: _ = updateFromUQN($uqnArray[0]);
	$: _ = updateType1Slider(type,aSlide,bSlide);
	$: _ = updateType2Slider(type,rSlide,thetaSlide);
	$: _ = updateType34Slider(type,rSlide,nSlide);
	$: _ = updateType6Slider(type,nSlide);
	$: _ = updateType5Slider(type,rSlide,thetaSlide,thetaSlide2,thetaSlide3,n);
	
	function updateFromUQN(u:number){
		// type
		if (u > 999999){
			type = "5";
		} else{
			type = u.toString()[0];
		};
		// type specific
		if (type=="1"){
			typeGroup1 = "1";
			[_,a,b,sign] = uqnSplit(u);
			[a,b] = signAssign(sign,a,b);
			aSlide = a; bSlide = b;
		} else if (type=="2"){
			typeGroup1 = "2";
			let theta1: number, theta2: number, theta3: number;
			[_,r,theta1,theta2,theta3] = uqnSplit(u);
			theta = (theta1*100+theta2*10+theta3)/100;
			if (theta>3.14){
				theta = -(6.28-theta);
			}
			rSlide = r; thetaSlide = theta;
		} else if (type=="3" || type=="4"){
			if (type=="3"){
				typeGroup1 = "1";
			} else{
				typeGroup1 = "2";
			}
			let n1: number, n2: number;
			[_,r,n1,n2] = uqnSplit(u);
			n = n1*10+n2;
			if (n>12){
				n = -(24-n);
			}
			let nFraction = new Fraction(n,12);
			nFraction.simplify();
			let nString = nFraction.toString();
			if (nString=="1"){
				nKatex = "\\pi";
			} else if (nString == "-1"){
				nKatex = "-\\pi";
			} else {
				nKatex = nString + "\\pi";
			}
			nKatex = "\\theta = " + nKatex;
			rSlide = r; nSlide = n;
		} else if (type=="5"){
			typeGroup1 = "5";
			let [power,n1,n2,n3,n4,n5,conj] = uqnSplit(u);
			n = power;
			let nBase10 = uqnJoin([n1,n2,n3,n4,n5]);
			multiplyGroup = (conj%5).toString();
			if (conj>4){
				r = 2;
			} else{
				r = 1;
			}
			n1 = Math.floor(nBase10/24/24);
			n2 = Math.floor((nBase10-n1*24*24)/24);
			n3 = nBase10%24;
			if (n1>12){
				n1 = -(24-n1);
			}
			if (n2>12){
				n2 = -(24-n2);
			}
			if (n3>12){
				n3 = -(24-n3);
			}
			let nFraction = new Fraction(n1,12);
			nFraction.simplify();
			let nString = nFraction.toString();
			if (nString=="1"){
				nKatex = "\\pi";
			} else if (nString == "-1"){
				nKatex = "-\\pi";
			} else {
				nKatex = nString + "\\pi";
			}
			nKatex = "\\theta_1 = " + nKatex;
			let nFraction2 = new Fraction(n2,12);
			nFraction2.simplify();
			let nString2 = nFraction2.toString();
			if (nString2=="1"){
				nKatex2 = "\\pi";
			} else if (nString2 == "-1"){
				nKatex2 = "-\\pi";
			} else {
				nKatex2 = nString2 + "\\pi";
			}
			nKatex2 = "\\theta_2 = " + nKatex2;
			let nFraction3 = new Fraction(n3,12);
			nFraction3.simplify();
			let nString3 = nFraction3.toString();
			if (nString3=="1"){
				nKatex3 = "\\pi";
			} else if (nString3 == "-1"){
				nKatex3 = "-\\pi";
			} else {
				nKatex3 = nString3 + "\\pi";
			}
			nKatex3 = "\\theta_3 = " + nKatex3;
			rSlide = r; nSlide = n;
			thetaSlide = n1; thetaSlide2 = n2; thetaSlide3 = n3;			
		} else if (type=="6"){
			typeGroup1 = "6";
			let n1: number, n2: number, realImag: number;
			[_,n1,n2,realImag] = uqnSplit(u);
			realImagRadio = realImag.toString();
			n = n1*10+n2;
			if (n>12){
				n = -(24-n);
			}			
			let nFraction = new Fraction(n,12);
			nFraction.simplify();
			let nString = nFraction.toString();
			if (nString=="1"){
				nKatex = "\\pi";
			} else if (nString == "-1"){
				nKatex = "-\\pi";
			} else {
				nKatex = nString + "\\pi";
			}
			nKatex = "\\theta = " + nKatex;
			nSlide = n;
		} else{
			throw "type outside 1-6";
		}
		uqnInput = u;
	}

	function updateFromRadio1(type:string){
		if (type=="5" && $uqnArray[0] < 999999){ // new mult
			uqnInput = random(5);
			uqnArray.update( original => [uqnInput, ...original.slice(1)])
		};
		if (type=="6" && ($uqnArray[0].toString().length == 7 || $uqnArray[0].toString()[0] != "6")){ // 
			uqnInput = random(6);
			uqnArray.update( original => [uqnInput, ...original.slice(1)])
		};
		if (type=="1"&& ($uqnArray[0].toString().length == 7 || !($uqnArray[0].toString()[0] == "1" || $uqnArray[0].toString()[0] == "3"))){ 
			uqnInput = random(1);
			uqnArray.update( original => [uqnInput, ...original.slice(1)])
		};
		if (type=="2"&& ($uqnArray[0].toString().length == 7 || !($uqnArray[0].toString()[0] == "2" || $uqnArray[0].toString()[0] == "4"))){ 
			uqnInput = random(2);
			uqnArray.update( original => [uqnInput, ...original.slice(1)])
		};
	}

	function updateFromRadio2(type:string){
		if (type=="1" && ($uqnArray[0].toString()[0] != "1")){ // 
			uqnInput = random(1);
			uqnArray.update( original => [uqnInput, ...original.slice(1)])
		};
		if (type=="2" && ($uqnArray[0].toString()[0] != "2")){ // 
			uqnInput = random(2);
			uqnArray.update( original => [uqnInput, ...original.slice(1)])
		};
		if (type=="3" && ($uqnArray[0].toString()[0] != "3")){ // 
			uqnInput = random(3);
			uqnArray.update( original => [uqnInput, ...original.slice(1)])
		};
		if (type=="4" && ($uqnArray[0].toString()[0] != "4")){ // 
			uqnInput = random(4);
			uqnArray.update( original => [uqnInput, ...original.slice(1)])
		};
	}

	function updateFromRadio3(conj:string){
		if (type=="5"){
			let [power,n1,n2,n3,n4,n5,c] = uqnSplit($uqnArray[0]);
			if (conj=="0" && c%5 !=0){ //
				if (c>4){
					uqnInput = uqnJoin([power,n1,n2,n3,n4,n5,5]);
				} else{
					uqnInput = uqnJoin([power,n1,n2,n3,n4,n5,0]);
				}
				uqnArray.update( original => [uqnInput, ...original.slice(1)])
			} else if (conj=="1" && c%5 !=1){ //
				if (c>4){
					uqnInput = uqnJoin([power,n1,n2,n3,n4,n5,6]);
				} else{
					uqnInput = uqnJoin([power,n1,n2,n3,n4,n5,1]);
				}
				uqnArray.update( original => [uqnInput, ...original.slice(1)])
			} else if (conj=="2" && c%5 !=2){ //
				if (c>4){
					uqnInput = uqnJoin([power,n1,n2,n3,n4,n5,7]);
				} else{
					uqnInput = uqnJoin([power,n1,n2,n3,n4,n5,2]);
				}
				uqnArray.update( original => [uqnInput, ...original.slice(1)])
			} else if (conj=="3" && c%5 !=3){ //
				if (c>4){
					uqnInput = uqnJoin([power,n1,n2,n3,n4,n5,8]);
				} else{
					uqnInput = uqnJoin([power,n1,n2,n3,n4,n5,3]);
				}
				uqnArray.update( original => [uqnInput, ...original.slice(1)])
			} else if (conj=="4" && c%5 !=4){ //
				if (c>4){
					uqnInput = uqnJoin([power,n1,n2,n3,n4,n5,9]);
				} else{
					uqnInput = uqnJoin([power,n1,n2,n3,n4,n5,4]);
				}
				uqnArray.update( original => [uqnInput, ...original.slice(1)])
			};
		}
	}

	function updateFromRadio4(rad:string){
		if (type=="6"){
			let [t,n1,n2,r] = uqnSplit($uqnArray[0]);
			if (rad=="0" && r !=0){
				uqnInput = uqnJoin([t,n1,n2,0]);
				uqnArray.update( original => [uqnInput, ...original.slice(1)])
			} else if (rad=="1" && r !=1){ //
				uqnInput = uqnJoin([t,n1,n2,1]);
				uqnArray.update( original => [uqnInput, ...original.slice(1)])
			} else if (rad=="2" && r !=2){
				let n = n1*10+n2;
				if (n%8==0){
					n2++;
				}
				uqnInput = uqnJoin([t,n1,n2,2]);
				uqnArray.update( original => [uqnInput, ...original.slice(1)])
			} else if (rad=="3" && r !=3){ //
				if (n%4==0){
					n2++;
				}
				uqnInput = uqnJoin([t,n1,n2,3]);
				uqnArray.update( original => [uqnInput, ...original.slice(1)])
			}
		}
	}

	function updateType1Slider(t:string, a1:number, b1:number){
		if (t=="1") {
			if (a1==0 && b1==0){
				if ($uqnArray[0].toString()[1]=="0"){ // a was originally 0
					aSlide = getRandomInt(1,9,true);
					a1 = aSlide;
				} else{
					bSlide = getRandomInt(1,9,true);
					b1 = bSlide;
				}
			}
			a = a1; b=b1;
			let s = 0;
			if (a<0 && b<0){
				s = 3;
			} else if (a<0){
				s = 2;
			} else if (b<0){
				s = 1;
			}
			uqnInput = uqnJoin([1,Math.abs(a1),Math.abs(b1),s]);
			uqnArray.update( original => [uqnInput, ...original.slice(1)])
		}
	}

	function updateType2Slider(t:string, r1:number, t1:number){
		if (t=="2") {
			if (t1==0){
				let [_,__,n1,n2,n3] = uqnSplit($uqnArray[0]);
				let n = n1*100+n2*10+n3;
				if (n>314){
					t1 = 0.01;
				} else{
					t1 = -0.01;
				}
			}
			r = r1; theta=t1;
			if (t1<0){
				if (t1.toFixed(2)=="-3.14"){
					t1 = 6.28;
				} else{
					t1 += 6.28;
				}
			}
			let ts1 = t1.toFixed(2)[0];
			let ts2 = t1.toFixed(2)[2];
			let ts3 = t1.toFixed(2)[3];
			uqnInput = uqnJoin([2,r1,ts1,ts2,ts3]);
			uqnArray.update( original => [uqnInput, ...original.slice(1)])
		}
	}

	function updateType34Slider(t:string, r1:number, n1:number){
		if (t=="3"||t=="4") {
			let oldN = Number($uqnArray[0].toString().slice(2))
			if (n1==-7){
				if (oldN==16){
					n1=-6;
				} else{
					n1=-8;
				}
			} else if (n1==-5){
				if (oldN==16){
					n1=-4;
				} else{
					n1=-6;
				}
			} else if (n1==-1){
				n1=2;
			} else if (n1==1){
				n1=-2;
			} else if (n1==0){
				if (oldN<13){
					n1=-2;
				} else{
					n1=2;
				}
			}else if (n1==5){
				if (oldN==4){
					n1=6;
				} else {
					n1=4;
				}
			} else if (n1==7){
				if (oldN==6){
					n1=8;
				} else{
					n1=6;
				}
			} else if (n1==11){
				if (oldN==10){
					n1=12;
				} else{
					n1=10;
				}
			}
			r=r1; nSlide=n1;;
			let nFraction = new Fraction(n1,12);
			nFraction.simplify();
			let nString = nFraction.toString();
			if (nString=="1"){
				nKatex = "\\pi";
			} else if (nString == "-1"){
				nKatex = "-\\pi";
			} else {
				nKatex = nString + "\\pi";
			}
			nKatex = "\\theta = " + nKatex;
			if (n1<0){
				n1+=24;
			}
			uqnInput = uqnJoin([t,r,Math.floor(n1/24),n1%24]);
			uqnArray.update( original => [uqnInput, ...original.slice(1)])
		}
	}

	function updateType6Slider(t:string, n1:number){
		if (t=="6") {
			let oldN = Number($uqnArray[0].toString().slice(1,3));
			let real = Number($uqnArray[0].toString()[3]);
			if (n1%6==0){
				if (oldN>12){
					oldN = -(24-oldN);
				}
				if (n1>oldN){
					n1--;
				} else{
					n1++;
				}
			}
			if (real==3){
				if (n1%4==0){
					if (oldN>12){
						oldN = -(24-oldN);
					}
					if (n1>oldN){
						n1--;
					} else{
						n1++;
					}
				}
			} else if (real==2){
				if (n1%8==0){
					if (oldN>12){
						oldN = -(24-oldN);
					}
					if (n1>oldN){
						n1--;
					} else{
						n1++;
					}
				}
			}
			nSlide=n1;;
			let nFraction = new Fraction(n1,12);
			nFraction.simplify();
			let nString = nFraction.toString();
			if (nString=="1"){
				nKatex = "\\pi";
			} else if (nString == "-1"){
				nKatex = "-\\pi";
			} else {
				nKatex = nString + "\\pi";
			}
			nKatex = "\\theta = " + nKatex;
			if (n1<0){
				n1+=24;
			}
			uqnInput = uqnJoin([t,Math.floor(n1/24),n1%24,real]);
			uqnArray.update( original => [uqnInput, ...original.slice(1)]);
		}
	}

	function updateType5Slider(t:string,r1:number,t1:number,t2:number,t3:number,n1:number){
		if (t=="5"){
			let [n2,k1,k2,k3,k4,k5,c] = uqnSplit($uqnArray[0]);
			let k = k1*10000+k2*1000+k3*100+k4*10+k5;
			let oldTheta1 = Math.floor(k/24/24);
			let oldTheta2 = Math.floor((k-oldTheta1*24*24)/24);
			let oldTheta3 = k%24;
			let oldR=2;
			let oldThetaSlide = oldTheta1>12? -(24-oldTheta1): oldTheta1;
			let oldThetaSlide2 = oldTheta2>12? -(24-oldTheta2): oldTheta2;
			let oldThetaSlide3 = oldTheta3>12? -(24-oldTheta3): oldTheta3;
			if (c<5){
				oldR=1;
			}
			if (r1 != oldR){
				r=r1;
				uqnInput = uqnJoin([n2,k1,k2,k3,k4,k5,(c+5)%10]);
				uqnArray.update( original => [uqnInput, ...original.slice(1)]);
			} else if (n1 != n2){
				uqnInput = uqnJoin([n1,k1,k2,k3,k4,k5,c]);
				uqnArray.update( original => [uqnInput, ...original.slice(1)]);
			} else if (oldThetaSlide != t1){
				if (t1==0){
					if (oldThetaSlide==1){
						if (t2 != -1 && t3 != -1){
							t1 = -1;
						} else if (t2 != -2 && t3 != -2){
							t1 = -2;
						} else{
							t1 = -3;
						}
					} else {
						if (t2 != 1 && t3 != 1){
							t1 = 1;
						} else if (t2 != 2 && t3 != 2){
							t1 = 2;
						} else{
							t1 = 3;
						}
					}
				} else if (t1==t2){
					t2 = 0;
					while (t2==0 || t2==t3){
						t2 = getRandomInt(-11,12);
					}
					let nFraction = new Fraction(t2,12);
					nFraction.simplify();
					let nString = nFraction.toString();
					if (nString=="1"){
						nKatex2 = "\\pi";
					} else if (nString == "-1"){
						nKatex2 = "-\\pi";
					} else {
						nKatex2 = nString + "\\pi";
					}
					nKatex2 = "\\theta_2 = " + nKatex2;
				} else if (t1==t3){
					t3 = 0;
					while (t3==0||t3==t2){
						t3 = getRandomInt(-11,12);
					}
					let nFraction = new Fraction(t3,12);
					nFraction.simplify();
					let nString = nFraction.toString();
					if (nString=="1"){
						nKatex3 = "\\pi";
					} else if (nString == "-1"){
						nKatex3 = "-\\pi";
					} else {
						nKatex3 = nString + "\\pi";
					}
					nKatex3 = "\\theta_3 = " + nKatex3;
				}
				thetaSlide = t1; thetaSlide2 = t2; thetaSlide3 = t3;
				let nFraction = new Fraction(t1,12);
				nFraction.simplify();
				let nString = nFraction.toString();
				if (nString=="1"){
					nKatex = "\\pi";
				} else if (nString == "-1"){
					nKatex = "-\\pi";
				} else {
					nKatex = nString + "\\pi";
				}
				nKatex = "\\theta_1 = " + nKatex;
				let t1New = t1<0? t1+24 : t1;
				let t2New = t2<0? t2+24 : t2;
				let t3New = t3<0? t3+24 : t3;
				let tNew = t1New*24*24+t2New*24+t3New;
				let k1New = Math.floor(tNew/10000);
				let k2New = Math.floor((tNew-k1New*10000)/1000);
				let k3New = Math.floor((tNew-k1New*10000-k2New*1000)/100);
				let k4New = Math.floor((tNew-k1New*10000-k2New*1000-k3New*100)/10);
				let k5New = tNew % 10;
				uqnInput = uqnJoin([n2,k1New,k2New,k3New,k4New,k5New,c]);
				uqnArray.update( original => [uqnInput, ...original.slice(1)]);
			} else if (oldThetaSlide2 != t2){
				if (t2==0){
					if (oldThetaSlide2==1){
						if (t1!=-1&&t3!=-1){
							t2 = -1;
						} else if (t1!=-2 && t3!=-2){
							t2 = -2;
						} else{
							t3 = -3;
						}
					} else {
						if (t1 != 1 && t3 != 1){
							t2 = 1;
						} else if (t1 != 2 && t3 != 2){
							t2 = 2;
						} else{
							t2 = 3;
						}
					}
				} else if (t2==t1){
					t1 = 0;
					while (t1==0 || t1==t3){
						t1 = getRandomInt(-11,12);
					}
					let nFraction = new Fraction(t1,12);
					nFraction.simplify();
					let nString = nFraction.toString();
					if (nString=="1"){
						nKatex = "\\pi";
					} else if (nString == "-1"){
						nKatex = "-\\pi";
					} else {
						nKatex = nString + "\\pi";
					}
					nKatex = "\\theta_1 = " + nKatex;
				} else if (t2==t3){
					t3 = 0;
					while (t3==0||t3==t2){
						t3 = getRandomInt(-11,12);
					}
					let nFraction = new Fraction(t3,12);
					nFraction.simplify();
					let nString = nFraction.toString();
					if (nString=="1"){
						nKatex3 = "\\pi";
					} else if (nString == "-1"){
						nKatex3 = "-\\pi";
					} else {
						nKatex3 = nString + "\\pi";
					}
					nKatex3 = "\\theta_3 = " + nKatex3;
				}
				thetaSlide = t1; thetaSlide2 = t2; thetaSlide3 = t3;
				let nFraction = new Fraction(t2,12);
				nFraction.simplify();
				let nString = nFraction.toString();
				if (nString=="1"){
					nKatex2 = "\\pi";
				} else if (nString == "-1"){
					nKatex2 = "-\\pi";
				} else {
					nKatex2 = nString + "\\pi";
				}
				nKatex2 = "\\theta_2 = " + nKatex2;
				let t1New = t1<0? t1+24 : t1;
				let t2New = t2<0? t2+24 : t2;
				let t3New = t3<0? t3+24 : t3;
				let tNew = t1New*24*24+t2New*24+t3New;
				let k1New = Math.floor(tNew/10000);
				let k2New = Math.floor((tNew-k1New*10000)/1000);
				let k3New = Math.floor((tNew-k1New*10000-k2New*1000)/100);
				let k4New = Math.floor((tNew-k1New*10000-k2New*1000-k3New*100)/10);
				let k5New = tNew % 10;
				uqnInput = uqnJoin([n2,k1New,k2New,k3New,k4New,k5New,c]);
				uqnArray.update( original => [uqnInput, ...original.slice(1)]);
			} else if (oldThetaSlide3 != t3){
				if (t3==0){
					if (oldThetaSlide3==1){
						if (t2!=-1 && t1 !=-1){
							t3=-1;
						} else if (t2!=-2 && t1!=-2){
							t3 = -2;
						} else{
							t3=-3;
						}
					} else {
						if (t2!=1 && t1!=1){
							t3=1;
						} else if (t2!=2 && t1!=2){
							t3=2;
						} else {
							t3=3;
						}
					}
				} else if (t3==t1){
					t1 = 0;
					while (t1==0 || t1==t3){
						t1 = getRandomInt(-11,12);
					}
					let nFraction = new Fraction(t1,12);
					nFraction.simplify();
					let nString = nFraction.toString();
					if (nString=="1"){
						nKatex = "\\pi";
					} else if (nString == "-1"){
						nKatex = "-\\pi";
					} else {
						nKatex = nString + "\\pi";
					}
					nKatex = "\\theta_1 = " + nKatex;
				} else if (t2==t3){
					t2 = 0;
					while (t2==0||t3==t2){
						t2 = getRandomInt(-11,12);
					}
					let nFraction = new Fraction(t2,12);
					nFraction.simplify();
					let nString = nFraction.toString();
					if (nString=="1"){
						nKatex2 = "\\pi";
					} else if (nString == "-1"){
						nKatex2 = "-\\pi";
					} else {
						nKatex2 = nString + "\\pi";
					}
					nKatex2 = "\\theta_2 = " + nKatex2;
				}
				thetaSlide = t1; thetaSlide2 = t2; thetaSlide3 = t3;
				let nFraction = new Fraction(t3,12);
				nFraction.simplify();
				let nString = nFraction.toString();
				if (nString=="1"){
					nKatex3 = "\\pi";
				} else if (nString == "-1"){
					nKatex3 = "-\\pi";
				} else {
					nKatex3 = nString + "\\pi";
				}
				nKatex3 = "\\theta_3 = " + nKatex3;
				let t1New = t1<0? t1+24 : t1;
				let t2New = t2<0? t2+24 : t2;
				let t3New = t3<0? t3+24 : t3;
				let tNew = t1New*24*24+t2New*24+t3New;
				let k1New = Math.floor(tNew/10000);
				let k2New = Math.floor((tNew-k1New*10000)/1000);
				let k3New = Math.floor((tNew-k1New*10000-k2New*1000)/100);
				let k4New = Math.floor((tNew-k1New*10000-k2New*1000-k3New*100)/10);
				let k5New = tNew % 10;
				uqnInput = uqnJoin([n2,k1New,k2New,k3New,k4New,k5New,c]);
				uqnArray.update( original => [uqnInput, ...original.slice(1)]);
			}
		}
	}

	function uqnClick(){
		if (check(uqnInput)){
			uqnArray.update( original => [uqnInput, ...original.slice(1)])
		} else{
			simpleDialog.open();
		}
	}	

</script>

<h2>Options</h2>
<hr>
<h3>UQN</h3>
<p>
	Retrieve a question by keying in a UQN (4-7 digits):
</p>
<Textfield class="shaped-outlined" variant="outlined" bind:value={uqnInput} label="UQN" type="number"/>
<Button on:click={uqnClick} variant="unelevated" class="button-shaped-round">
	<Label>Generate question</Label>
</Button>
<hr>
<h3>
	Question construction tools
</h3>
<p> 
	Use the options below to modify question (a)
</p>
<QnComponent uqn={$uqnArray[0]}/>
<hr>
<div>
	<p>First choose the general type of question:</p>
	<FormField>
		<Radio bind:group={typeGroup1} value=1/>
		<span slot="label">Convert to exponential form</span>
	</FormField>
	<FormField>
		<Radio bind:group={typeGroup1} value=2/>
	<span slot="label">Convert to cartesian form</span>
	</FormField>
	<FormField>
		<Radio bind:group={typeGroup1} value=5/>
		<span slot="label">Multiplication, division, powers, conjugate</span>
	</FormField>
	<FormField>
		<Radio bind:group={typeGroup1} value=6/>
		<span slot="label">Purely imaginary, real</span>
	</FormField>
</div>
<hr>
{#if typeGroup1 == "1" || typeGroup1 == "2"}
	<p>Next choose the type of complex numbers:</p>
	{#if typeGroup1 == "1"}
		<FormField>
			<Radio bind:group={type} value=1/>
			<span slot="label">General <Katex math="a+bi"/></span>
		</FormField>
		<FormField>
			<Radio bind:group={type} value=3/>
		<span slot="label">Special angles</span>
		</FormField>
	{:else if typeGroup1 == "2"}
			<FormField>
				<Radio bind:group={type} value=2/>
			<span slot="label">General <Katex math={"re^{i\\theta}"}/></span>
			</FormField>
			<FormField>
				<Radio bind:group={type} value=4/>
			<span slot="label">Special angles</span>
			</FormField>
	{/if}
{:else if typeGroup1=="6"}
	<FormField>
		<Radio bind:group={realImagRadio} value=0/>
		<span slot="label">Real</span>
	</FormField>
	<FormField>
		<Radio bind:group={realImagRadio} value=1/>
	<span slot="label">Real and positive</span>
	</FormField>
	<FormField>
		<Radio bind:group={realImagRadio} value=2/>
		<span slot="label">Real and negative</span>
	</FormField>
	<FormField>
		<Radio bind:group={realImagRadio} value=3/>
	<span slot="label">Purely imaginary</span>
	</FormField>
{:else if typeGroup1=="5"}
	<FormField>
		<Radio bind:group={multiplyGroup} value=0/>
		<span slot="label"><Katex math={fractionBuilder("z_1 z_2^*","z_3^n",true)}/></span>
	</FormField>
	<FormField>
		<Radio bind:group={multiplyGroup} value=1/>
	<span slot="label"><Katex math={fractionBuilder("z_1 z_2^n","z_3^*",true)}/></span>
	</FormField>
	<FormField>
		<Radio bind:group={multiplyGroup} value=2/>
		<span slot="label"><Katex math={fractionBuilder("\\left(z_1 z_2^n\\right)^*","z_3",true)}/></span>
	</FormField>
	<FormField>
		<Radio bind:group={multiplyGroup} value=3/>
		<span slot="label"><Katex math={"\\left (" + fractionBuilder("z_1^n z_2","z_3", true)+"\\right)^*"}/></span>
	</FormField>
	<FormField>
		<Radio bind:group={multiplyGroup} value=4/>
		<span slot="label"><Katex math={fractionBuilder("\\left(z_1^* z_2\\right)^n","z_3",true)}/></span>
	</FormField>
{/if}
<hr>
<p>
	Use the sliders belows to choose different options to craft your own unique question.
</p>
{#if type=="1"}
	<div>
		<FormField align="end" style="display: flex; width: 90%" >
			<Slider bind:value={aSlide} min={-9} max={9} step={1} style="width:80%" discrete displayMarkers/>
			<span slot="label" style="padding-right: 12px; width: max-content; display: block;"><Katex math={"a="+a.toString()}/></span>
		</FormField>
		<FormField align="end" style="display: flex; width: 90%" >
			<Slider bind:value={bSlide} min={-9} max={9} step={1} style="width:80%" discrete displayMarkers/>
			<span slot="label" style="padding-right: 12px; width: max-content; display: block;"><Katex math={"b="+b.toString()}/></span>
		</FormField>
	</div>
{:else if type=="2"}
	<div>
		<FormField align="end" style="display: flex; width: 90%" >
			<Slider bind:value={rSlide} min={1} max={9} step={1} style="width:80%" discrete displayMarkers/>
			<span slot="label" style="padding-right: 12px; width: max-content; display: block;"><Katex math={"r="+r.toString()}/></span>
		</FormField>
		<FormField align="end" style="display: flex; width: 90%" >
			<Slider bind:value={thetaSlide} min={-3.13} max={3.14} step={0.01} style="width:80%" displayMarkers/>
			<span slot="label" style="padding-right: 12px; width: max-content; display: block;"><Katex math={"\\theta="+theta.toFixed(2)}/></span>
		</FormField>
	</div>
{:else if type=="3"||type=="4"}
	<div>
		<FormField align="end" style="display: flex; width: 90%" >
			<Slider bind:value={rSlide} min={1} max={9} step={1} style="width:80%" discrete displayMarkers/>
			<span slot="label" style="padding-right: 12px; width: max-content; display: block;"><Katex math={"r="+r.toString()}/></span>
		</FormField>
		<FormField align="end" style="display: flex; width: 90%" >
			<Slider bind:value={nSlide} min={-10} max={12} step={1} style="width:80%" displayMarkers/>
			<span slot="label" style="padding-right: 12px; width: max-content; display: block;"><Katex math={nKatex}/></span>
		</FormField>
	</div>
{:else if type=="6"}
	<div>
		<FormField align="end" style="display: flex; width: 90%" >
			<Slider bind:value={nSlide} min={-11} max={11} step={1} style="width:80%" displayMarkers/>
			<span slot="label" style="padding-right: 12px; width: max-content; display: block;"><Katex math={nKatex}/></span>
		</FormField>
	</div>
{:else if type=="5"}
	<Katex math={"z_1 = re^{i\\theta_1}, z_2 = e^{i\\theta_2}, z_3 = e^{i\\theta_3} "}/>
	<div>
		<FormField align="end" style="display: flex; width: 90%" >
			<Slider bind:value={rSlide} min={1} max={2} step={1} style="width:80%" discrete displayMarkers/>
			<span slot="label" style="padding-right: 12px; width: max-content; display: block;"><Katex math={"r="+r.toString()}/></span>
		</FormField>
		<FormField align="end" style="display: flex; width: 90%" >
			<Slider bind:value={thetaSlide} min={-11} max={12} step={1} style="width:80%" displayMarkers/>
			<span slot="label" style="padding-right: 12px; width: max-content; display: block;"><Katex math={nKatex}/></span>
		</FormField>
		<FormField align="end" style="display: flex; width: 90%" >
			<Slider bind:value={thetaSlide2} min={-11} max={12} step={1} style="width:80%" displayMarkers/>
			<span slot="label" style="padding-right: 12px; width: max-content; display: block;"><Katex math={nKatex2}/></span>
		</FormField>
		<FormField align="end" style="display: flex; width: 90%" >
			<Slider bind:value={thetaSlide3} min={-11} max={12} step={1} style="width:80%" displayMarkers/>
			<span slot="label" style="padding-right: 12px; width: max-content; display: block;"><Katex math={nKatex3}/></span>
		</FormField>
		<FormField align="end" style="display: flex; width: 90%" >
			<Slider bind:value={n} min={2} max={9} step={1} style="width:80%" discrete displayMarkers/>
			<span slot="label" style="padding-right: 12px; width: max-content; display: block;"><Katex math={"n="+n.toString()}/></span>
		</FormField>
	</div>
{/if}


<Dialog bind:this={simpleDialog}>
	<!-- Title cannot contain leading whitespace due to mdc-typography-baseline-top() -->
	<Title>Invalid UQN</Title>
	<Content>
		You have keyed an invalid UQN. Please try again.
	</Content>
	<Actions>
		<Button>
			<Label>OK</Label>
		</Button>
	</Actions>
</Dialog>
<hr>